import React, { useState } from "react";
import { ArchiveApi, SearchHistory } from "../../axios";
import DateControl from "./DateControl";

interface Props {
	onSearch: (search: SearchHistory) => void,
};

/**
 * 送信履歴検索条件用コンポーネント
 * 
 * @returns 
 */
export default function ArchiveCondition(props: Props): JSX.Element {

	/** 検索履歴 */
	const [searchHistory, setSearchHistory] = useState<SearchHistory>({});

	/** 表示更新用キー */
	const [key, setKey] = useState<number>(Date.now());

	/**
	 * 送信日_from変更イベント
	 * 
	 * @param value 
	 */
	const handleSendDateFromChange = (value?: string) => {
		searchHistory.send_date_from = value;
	};

	/**
	 * 送信日_to変更イベント
	 * 
	 * @param value 
	 */
	const handleSendDateToChange = (value?: string) => {
		searchHistory.send_date_to = value;
	};

	/**
	 * 発行日_from変更イベント
	 * 
	 * @param value 
	 */
	const handleIssuedDateFromChange = (value?: string) => {
		searchHistory.issued_date_from = value;
	};

	/**
	 * 発行日_to変更イベント
	 * 
	 * @param value 
	 */
	const handleIssuedDateToChange = (value?: string) => {
		searchHistory.issued_date_to = value;
	};

	/**
	 * 文書名変更イベント
	 * 
	 * @param value 
	 */
	const handleDocNameChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.doc_name = toString(event?.target.value!);
	};

	/**
	 * ファイル名変更イベント
	 * 
	 * @param value 
	 */
	const handleFileNameChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.file_name = toString(event?.target.value!);
	};

	/**
	 * 取引先変更イベント
	 * 
	 * @param value 
	 */
	const handleCustomerChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.customer = toString(event?.target.value!);
	};

	/**
	 * 金額_from変更イベント
	 * 
	 * @param value 
	 */
	const handleAmountFromChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.amount_from = toNumber(event?.target.value!);
	};

	/**
	 * 金額_to変更イベント
	 * 
	 * @param value 
	 */
	const handleAmountToChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.amount_to = toNumber(event?.target.value!);
	};

	/**
	 * 検索キー１変更イベント
	 * 
	 * @param value 
	 */
	const handleSearchKey1Change = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.search_key_1 = toString(event?.target.value!);
	};

	/**
	 * 検索キー２変更イベント
	 * 
	 * @param value 
	 */
	const handleSearchKey2Change = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.search_key_2 = toString(event?.target.value!);
	};

	/**
	 * 検索キー３変更イベント
	 * 
	 * @param value 
	 */
	const handleSearchKey3Change = (event?: React.ChangeEvent<HTMLInputElement>) => {
		searchHistory.search_key_3 = toString(event?.target.value!);
	};

	/**
	 * 検索ボタンクリック時イベント
	 */
	const handleSearchClick = async () => {
		if (validate(searchHistory) == false) {
			return;
		}
		props.onSearch({ ...searchHistory });
	};

	/**
	 * クリアボタンクリック時イベント
	 */
	const handleClearClick = async () => {
		setSearchHistory({});
		setKey(Date.now());
	};

	/**
	 * フォームの内容をチェックする。
	 * 
	 * @param searchHistory 
	 * @returns 
	 */
	const validate = (searchHistory: SearchHistory) => {
		if (searchHistory.send_date_from == '--------') {
			alert('送信日の開始日の指定が正しくありません。');
			return false;
		}
		if (searchHistory.send_date_to == '--------') {
			alert('送信日の終了日の指定が正しくありません。');
			return false;
		}
		if (searchHistory.issued_date_from == '--------') {
			alert('発行日の開始日の指定が正しくありません。');
			return false;
		}
		if (searchHistory.issued_date_to == '--------') {
			alert('発行日の終了日の指定が正しくありません。');
			return false;
		}
		if (searchHistory.amount_from == -1) {
			alert('金額の下限の指定が正しくありません。');
			return false;
		}
		if (searchHistory.amount_to == -1) {
			alert('金額の上限の指定が正しくありません。');
			return false;
		}
		return true;
	};

	/**
	 * 空文字列をundefinedに変換する。
	 * 
	 * @param value 
	 * @returns 
	 */
	const toString = (value?: string) => {
		return (value === '') ? undefined : value;
	};

	/**
	 * 数値に変換する。変換できない場合は-1に変換する。
	 * 
	 * @param value 
	 * @returns 
	 */
	const toNumber = (value?: string) => {
		if (value == undefined || value.trim() == '') {
			return undefined;
		} else if (isNaN(Number(value))) {
			return -1;
		} else {
			return Number(value);
		}
	}

	// 描画する
	return (
		<>
			<h5>ファイル検索&nbsp;</h5>
			<div className="control-group" key={key}>
				<div>
					<table width="100%" className="hyosearch">
						<tbody>
							<tr>
								<td scope="row">送信日</td>
								<td scope="row" colSpan={3}>
									<div>
										<DateControl onChange={handleSendDateFromChange} />～&nbsp;
										<DateControl onChange={handleSendDateToChange} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">発行日</td>
								<td scope="row">
									<div>
										<DateControl onChange={handleIssuedDateFromChange} />～&nbsp;
										<DateControl onChange={handleIssuedDateToChange} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">取引先</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="customer" onChange={handleCustomerChange} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">文書名</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="doc_name" onChange={handleDocNameChange} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">ファイル名</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="file_name" onChange={handleFileNameChange} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">金額</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="amount_from" onChange={handleAmountFromChange} size={35} />
										&nbsp;～&nbsp;
										<input type="text" name="amount_to" onChange={handleAmountToChange} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">検索キー１</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="txtFileName" onChange={handleSearchKey1Change} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">検索キー２</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="txtFileName" onChange={handleSearchKey2Change} size={35} />
									</div>
								</td>
							</tr>
							<tr>
								<td scope="row">検索キー３</td>
								<td scope="row" colSpan={3}>
									<div>
										<input type="text" name="txtFileName" onChange={handleSearchKey3Change} size={35} />
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className="control-group">
				<div className="controls">
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleSearchClick}>検索</button>&nbsp;
					<button className="btn btn-default btn-secondary pull-center" type="button" onClick={handleClearClick}>クリア</button>
				</div>
			</div>
		</>
	);

}
